import { render, staticRenderFns } from "./AdminProjectPermissions.vue?vue&type=template&id=c41b5b9c&scoped=true&"
import script from "./AdminProjectPermissions.vue?vue&type=script&lang=js&"
export * from "./AdminProjectPermissions.vue?vue&type=script&lang=js&"
import style0 from "./AdminProjectPermissions.vue?vue&type=style&index=0&id=c41b5b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41b5b9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VLayout,VSpacer,VTooltip})
